import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import Layout from './components/Layout/Layout';
import RouteTransition from './components/Layout/RouteTransition';
import GlobalStyles from './styles/GlobalStyles';
import Home from './pages/Home';

const Project = lazy(() => import('./pages/Project'));
const WritingIndex = lazy(() => import('./pages/WritingIndex'));

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <Layout>
          <RouteTransition>
            {location => (
              <Suspense fallback={null}>
                <Routes location={location}>
                  <Route path="/" element={<Home />} />
                  <Route path="/writing" element={<WritingIndex />} />
                  <Route path="/projects/:slug" element={<Project />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            )}
          </RouteTransition>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}
